import { Project } from "./project-model";
import { Task } from "./task";

export type approvalStatusType = 'NONE' | 'PENDING_APPROVAL' | 'APPROVED' | 'DENIED' | 'DENIED_BY_TESSCO' | 'TESSCO_REVIEW' | 'QUOTED_AWAITING_PO' | 'TESSCO_REVIEW_COMPLETE' | 'ORDER_PLACED';

export class Worksheet {
  approvalAmount: number;
  approvalId: string;
  approvalIdTierTwo: string;
  approvalStatus: approvalStatusType;
  approvalStatusTierTwo: approvalStatusType;
  approvalAuthorityUserId: string;
  contractorId: string;
  createdBy: string;
  id: string;
  initiatorId: string;
  quoteNumber: string;
  orderId: string;
  orderNumber: string;
  shipToAddressId: string;
  confirmedShipToAddressId: boolean;
  siteName: string;
  siteNumber: string;
  projectId: string;
  bomId: string;
  orderDeliveryStatusId: string;
  orderDeliveryStatus: string;
  isOrderCommitted: boolean;
  totalMerchandiseAmountToShip: number;
  totalTaxAmount: number;
  lastOrderSimulationId: string;
  lastQuoteTransactionId: string;
  lastOrderTransactionId: string;
  busy: boolean;
  watchingCount: number;
  currentWorksheetWatchers: string[];
  paymentId: string;
  payment: PaymentInfo;
  actionDues: ActionDue[];
  tier1ApprovalTeamID: string;
  project: Project;
  shipmentDetails: ShipmentDetails[];
  confirmedReceipt: boolean;
  confirmedNeedByDate: boolean;
  requestedDeliveryDate: string;
  isQuoted: boolean;
  secondaryAddressId: string;
  modifiedUserId: string;
  // For APPROVER on order table
  approver: string;
  // For TASKS
  tasks: Task[] = [];
  // For HEALTH ISSUES
  healthIssues: number;
  // For updating Task
  taskType: 'APPROVAL' | 'ADDRESS VERIFICATION' | 'CABLE CUT' | 'REQUESTED DELIVERY DATE' | 'RECEIPT OF GOODS' | 'PROGRAMMABLE PRODUCT';
  atcApproverId: string;
  purchaseOrderNumber : string;
  worksheetPurchasePlanCode: string;
  initiatorTeamId: string;

  //Input for atc apporver, contractor and initiator
  contractorTeamName: string;
  atcApproverName: string;
  initiatorTeamName: string;
  emailIds: string;
}

class ActionDue {
  code: string;
  description: string;
  dueDate: string;
}

export class PaymentInfo {
  createdBy: string;
  id: string;
  poNumber: string;
  transactionNumber: string;
  type: string;
}

export class ShipmentDetails {
  accountNumber: string;
  addrLineOne: string;
  addrLineThree: string;
  addrLineTwo: string;
  altOrderNum: string;
  bookingCode: string;
  city: string;
  contactName: string;
  dateOrderPlaced: string;
  id: string;
  lineItemCount: 0;
  locationNumber: string;
  orderHeaders: OrderHeader[];
  postalCode: string;
  purchaseOrder: string;
  state: string;
}

export class OrderHeader {
  accountNumber: string;
  carrierId: string;
  id: string;
  invoiceDate: string;
  orderLines: OrderLine[];
  purchaseOrder: string;
  salesOrderNumber: string;
  shipDate: string;
  trackingNumber: string;
  trackingUrl: string;

  constructor() {
    this.carrierId = '';
    this.shipDate = '';
    this.trackingNumber = '';
  }
}

export class OrderLine {
  altDescription: string;
  bookLineNum: 0;
  id: string;
  itemId: 0;
  laborLine: 0;
  laborQty: 0;
  qtyOnOrder: 0;
  qtySchedToShip: 0;
  qtyShipped: 0;
  shippingStatus: string;
  sku: string;
  unitOfMeasure: string;
  unitOfMeasureQty: 0;
  unitPrice: 0;
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/api/models/worksheet.ts